module.exports = __webpack_public_path__ + "static/media/recheada.497f47b1.png";